import { render } from "./LoginRoblox.vue?vue&type=template&id=7817d1ea&scoped=true"
import script from "./LoginRoblox.vue?vue&type=script&lang=js"
export * from "./LoginRoblox.vue?vue&type=script&lang=js"

import "./LoginRoblox.vue?vue&type=style&index=0&id=7817d1ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7817d1ea"]])

export default __exports__